module.exports = __webpack_public_path__ + "img/yonghuxieyi.fbd10083.png";